<template>
  <div>
    <v-btn v-if="isAdvari" depressed @click="sortInventory" color="secondary rounded-lg white--text"
      >مرتب سازی کاردکس کالا
    </v-btn>

    <v-dialog
      class="rounded-lg"
      v-model="errorDialog"
      scrollable
      max-width="1200px"
      transition="dialog-transition"
      :fullscreen="isPrinting"
    >
      <v-card class="rounded-lg pa-2">
        <v-card-title>
          مرتب سازی با موفقیت انجام شد. لیست کالا های منفی شده
        </v-card-title>

        <v-card-text>
          <m-datatable :headers="errorHeaders" :items="errors" :filters.sync="errorFilters" :isDialog="true">
            <template #item.factor_item_order="{ item }">{{ +item.factor_item_order + 1 }}</template>
            <template #item.form.code="{ item }">
              <v-btn :to="getFormLink(item)" rounded outlined color="blue white--text" target="_blank"
                >{{ item.form.code }}
              </v-btn>
            </template>
            <template #item.inventory="{ item }">
              <open-inventory-btn :wareId="item.ware_id" />
            </template>
          </m-datatable>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { FactorTypes } from "@/variables";
import MDatatable from "@/components/m-datatable";
import OpenInventoryBtn from "@/components/btns/OpenInventoryBtn";

export default {
  name: "SortInventory",
  components: { MDatatable, OpenInventoryBtn },
  props: {
    datatable: {
      default: null,
    },
  },
  data() {
    return {
      errors: [],
      errorDialog: false,
      errorFilters: {},
      errorHeaders: [
        {
          text: "کالا",
          value: "ware_name",
        },
        {
          text: "انبار",
          value: "warehouse_name",
        },
        {
          text: "کاردکس",
          value: "inventory",
          sortable: false,
          filterable: false,
          hideInExport: true,
        },
      ],
    };
  },
  methods: {
    sortInventory() {
      if (confirm(` آیا مرتب سازی کاردکس در سال مالی ${this.financialYear.name} انجام شود؟ `)) {
        const options = {
          url: this.endpoint(`wares/sortInventory`),
          method: "post",
        };
        this.request({
          ...options,
          success: (data) => {
            this.successNotify();
            if (this.datatable) {
              this.datatable.getDataFromApi();
            }

            this.errors = data;
            this.errorDialog = true;
          },
        });
      }
    },
  },
};
</script>
